import { DialogRef } from "@angular/cdk/dialog";
import { CommonModule } from "@angular/common";
import { Component, inject, OnInit, signal } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { lastValueFrom } from "rxjs";
import { AuthService } from "src/app/pages/auth";
import { UserService } from "src/app/services/api/user.service";
import { SweetAlertService } from "src/app/services/sweet-alert-service/sweet-alert.service";
import { ToastService } from "src/app/services/toast-service/toast.service";
import { SharedModule } from "src/shared/shared.module";
import { LabelMode } from "src/utils/label-mode.enum";
import { MustMatch } from "src/utils/must-match.validator";
import { SetError } from "src/utils/set-error.validator";

@Component({
  selector: "app-reset-password",
  imports: [
    CommonModule,
    SharedModule,
    TranslateModule,
    ReactiveFormsModule,
    FormsModule,
  ],
  templateUrl: "./reset-password.component.html",
  styleUrl: "./reset-password.component.scss",
})
export class ResetPasswordComponent implements OnInit {
  #dialogRef = inject(DialogRef<ResetPasswordComponent>);
  #userService = inject(UserService);
  #fb = inject(FormBuilder);
  #swalService = inject(SweetAlertService);
  #authService = inject(AuthService);
  #toastService = inject(ToastService);
  #route = inject(ActivatedRoute);
  #router = inject(Router);

  form: FormGroup;
  error: any;
  LabelMode = LabelMode;
  token = signal<string | null>(null);

  currentUser = this.#authService.currentUser()?.user;
  constructor() {
    this.#route.queryParams.subscribe((params) => {
      if (params.token?.length) {
        this.token.set(params.token);
      } else {
        this.onClose();
      }
    });
  }
  ngOnInit(): void {
    this.buildForm();

    if (this.token()?.length) {
      this.form.patchValue({ token: this.token() });
    }
  }

  buildForm() {
    this.form = this.#fb.group(
      {
        password: [null, Validators.required],
        password_confirmation: [null, Validators.required],
        token: [null, Validators.required],
      },
      { validator: MustMatch("password", "password_confirmation") }
    );
  }
  async resetPassword() {
    // this.notifierService.notify('default', 'ระบบยังไม่พร้อมใช้งาน');
    this.error = {};
    if (this.form.invalid) {
      this.error = SetError(this.form);
      return;
    }

    await this.#swalService.swalConfirmation();

    const payload = this.form.getRawValue();
    try {
      this.#swalService.swalLoading();
      const reset = await lastValueFrom(
        this.#userService.resetPassword(payload)
      );
      this.#swalService.swalClose();
      this.#toastService.toastSuccess("เปลี่ยนรหัสผ่านสำเร็จ");
      this.onClose();
    } catch (error: any) {
      this.#swalService.swalClose();

      const closeAfter = this.showError(error.error.error);
      setTimeout(() => {
        this.onClose();
      }, closeAfter);
      // this.#toastService.toastError(error.error.error);
    }
  }

  onClose() {
    this.#dialogRef.close();
    this.#router.navigateByUrl("/home");
  }

  /** Shows the error and returns how long (ms) to leave it up before closing. */
  showError(err_message: string): number {
    switch (err_message) {
      case "token is invalid.":
        this.#toastService.toastError(
          "ลิงก์ที่ใช้ยืนยันหมดอายุ กรุณาทำรายการใหม่"
        );
        return 500;
      // case "CP04":
      //   this.#toastService.toastError("รหัสผ่านเก่าไม่ถูกต้อง");
      //   break;
      default:
        this.#toastService.toastError("มีข้อผิดพลาดกรุณาตรวจสอบ");
        return 2000;
    }
  }
}
